import React, { useState } from "react";
//--------Material React Table------//
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"; //material-react-table
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";

function CommonMatrialReactTableServerSideRender({
  columns,
  data,
  MainHeading,
  ReportHeading,
  startdate,
  enddate,
  columnGrouping,
  columnsVisibility,
  enableRowActions,
  enableRowSelection,
  renderRowActionMenuItems,
  renderTopToolbarCustomActions,
  density,
  showGlobalFilter,
  showColumnFilters,
  expanded,
  pagination,
  rowCount,
  setColumnFilters,
  setGlobalFilter,
  setPagination,
  setSorting,
  setColumnOrder,
  state,
  setColumnVisibility,
  columnPinning = {},
}) {
  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_Report.xlsx`);
  };

  const downloadPDF = (rows, field, visibleColumns) => {
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = MainHeading;
    let reportHeading = ReportHeading;
    let reportDateHeading =
      startdate && enddate ? `From: ${startdate} To: ${enddate}` : "All Date";

    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );

    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data.map((el) => {
        return {
          ...el,
          OpenBalance:
            el.OpenBalance == null || el.OpenBalance === "NaN"
              ? ""
              : parseFloat(el.OpenBalance),
          ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
          DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
        };
      });
    }

    const doc = new jsPDF("p", "mm", "a4");

    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;

    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);

    doc.setFontSize(10);

    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);

      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];

      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);

      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;

      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed

      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";

            if (typeof dataValue === "number") {
              value = parseFloat(dataValue);
            } else if (typeof dataValue === "string") {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("MM-DD-YYYY (HH:mm)");
            }

            return value;
          });

          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };

      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      doc.text(reportMainHeading, centerX, 10);

      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      doc.text(reportHeading, centerXHeading, 15);

      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 20);

      doc.setPage(currentPage);
      doc.autoTable(content);

      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }

    doc.save(`${ReportHeading}.pdf`);
  };

  const initialColumnSizing = {
    // "mrt-row-select" : 100,
    // Name: 280,
    // Categoryfullpath: 150,
    // Itemnumber: 180
  };

  // ✅ Store the current sizing in state
  // const [columnSizing, setColumnSizing] = useState(initialColumnSizing);

  // // ✅ This runs whenever the user resizes a column
  // const handleColumnSizingChange = (newSizing) => {
  //   console.log("New Column Sizes:", newSizing);
  //   // Here you can:
  //   // - Save to server
  //   // - Save to localStorage
  //   // - Or anything else
  //   setColumnSizing(newSizing);
  // };

  // console.log(columnSizing, "columnSizing");

  const table = useMaterialReactTable({
    columns,
    data,
    columnSizing: {
      "mrt-row-select": 50,
      "mrt-row-actions": 50,
    },
    layoutMode: "grid-no-grow", // 'semantic' | 'grid' | 'grid-no-grow'

    // defaultColumn: {
    //   minSize: 150, //allow columns to get smaller than default
    //   maxSize: 1500, //allow columns to get larger than default
    //   size: 250, //make columns wider by default
    // },
    // enableRowSelection: true, //table options as options to this hook
    enableColumnResizing: true,
    enableGrouping: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableRowSelection: enableRowSelection,
    enableColumnOrdering: true,
    sortDescFirst: true,
    enableColumnFilterModes: true,
    enableColumnPinning: true,
    enablePagination: true,
    enableRowActions: enableRowActions,
    muiTableBodyProps: {
      sx: () => ({
        "& tr:nth-of-type(even)": {
          backgroundColor: "var(--datatable-row-background-color)",
          //'rgb(237 237 233 / 63%)'
        },
        "& td": {
          borderRight: "1px solid var(--datatable-row-background-hover-color)",
          lineHeight: "16px",
          fontWeight: "400",
          fontSize: "12px",
          color: "var(--primary-color-800)",
          fontFamily: "Inter",
        },

        "& tr": {
          lineHeight: "16px",
          fontWeight: "400",
          fontSize: "12px",
          color: "var(--primary-color-800)",
          fontFamily: "Inter",
        },
      }),
    },
    // muiTableBodyCellProps:{
    //   sx: { borderLeft: "1px solid #E0E0E0" },
    // },
    muiTableHeadCellProps: {
      sx: (theme) => ({
        background: "var(--datatable-row-background-color)", //'#e9e9e9',
        borderRight: "1px solid var(--datatable-row-background-hover-color)",
        lineHeight: "16px",
        fontWeight: "500",
        fontSize: "14px",
        color: "var(--primary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiToolbarAlertBannerProps: {
      isError: () => ({
        color: "error",
        children: "Error loading data",
      }),
      sx: (theme) => ({
        background: "var(--datatable-row-background-color)", //'#e9e9e9',
        lineHeight: "16px",
        fontWeight: "500",
        fontSize: "14px",
        color: "var(--primary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiSelectCheckboxProps: {
      sx: (theme) => ({
        lineHeight: "16px",
        fontWeight: "400",
        fontSize: "12px",
        color: "var(--prinary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiSelectAllCheckboxProps: {
      sx: (theme) => ({
        lineHeight: "16px",
        fontWeight: "400",
        fontSize: "12px",
        color: "var(--prinary-color-800)",
        fontFamily: "Inter",
      }),
    },
    muiTableContainerProps: { sx: { maxHeight: "fit-content" } },
    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 300, 500, 1000],
    },
    initialState: {
      density: density,
      expanded: expanded, //expand all groups by default
      grouping: columnGrouping, //an array of columns to group by by default (can be multiple)
      columnVisibility: columnsVisibility,
      showGlobalFilter: showGlobalFilter,
      pagination: pagination,
      showColumnFilters: showColumnFilters,
      columnPinning: columnPinning, // simple format for left and right { left: ['CustomerName'], right: ['SyncStatusName'] }
      // sorting: { id: "Name", desc: false }, //sort by state by default
    },
    renderRowActionMenuItems: renderRowActionMenuItems,
    renderTopToolbarCustomActions: renderTopToolbarCustomActions,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    positionGlobalFilter: "left",
    rowCount: rowCount,
    onColumnFiltersChange: setColumnFilters, // for termp comment filteron column
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onColumnOrderChange: setColumnOrder,
    onColumnVisibilityChange: setColumnVisibility,
    // onColumnSizingChange: handleColumnSizingChange,
    // state: {...state, columnSizing}
    state: state,
  });

  console.log(columns, data, "Ashish");

  return (
    <>
      <MaterialReactTable
        table={table} //only pass in table instead of all table options
      />
      {/* <MaterialReactTable
        columns={columns}
        data={data}
        // positionPagination='top'
        enableColumnResizing
        enableGrouping
        enableStickyHeader
        enableStickyFooter
        enableRowSelection
        enableColumnOrdering
        sortDescFirst
        enableColumnFilterModes
        enablePagination
        // groupedColumnMode="remove" // remove, reorder, false
        muiTableBodyProps={{
          sx: () => ({
            "& tr:nth-of-type(even)": {
              backgroundColor: "var(--datatable-row-background-color)",
              //'rgb(237 237 233 / 63%)'
            },
            "& td": {
              borderRight:
                "1px solid var(--datatable-row-background-hover-color)",
              lineHeight: "16px",
              fontWeight: "400",
              fontSize: "12px",
              color: "var(--primary-color-800)",
              fontFamily: "Inter",
            },

            "& tr": {
              lineHeight: "16px",
              fontWeight: "400",
              fontSize: "12px",
              color: "var(--primary-color-800)",
              fontFamily: "Inter",
            },
          }),
        }}
        muiTableHeadCellProps={{
          sx: (theme) => ({
            background: "var(--datatable-row-background-color)", //'#e9e9e9',
            borderRight:
              "1px solid var(--datatable-row-background-hover-color)",
            lineHeight: "16px",
            fontWeight: "500",
            fontSize: "14px",
            color: "var(--primary-color-800)",
            fontFamily: "Inter",
          }),
        }}
        muiToolbarAlertBannerProps={
          // isError
          // ? {
          //   color: "error",
          //   children: "Error loading data",
          // }
          // : undefined
          {
            isError: () => ({
              color: "error",
              children: "Error loading data",
            }),
            sx: (theme) => ({
              background: "var(--datatable-row-background-color)", //'#e9e9e9',
              lineHeight: "16px",
              fontWeight: "500",
              fontSize: "14px",
              color: "var(--primary-color-800)",
              fontFamily: "Inter",
            }),
          }
        }
        muiSelectCheckboxProps={{
          sx: (theme) => ({
            lineHeight: "16px",
            fontWeight: "400",
            fontSize: "12px",
            color: "var(--prinary-color-800)",
            fontFamily: "Inter",
          }),
        }}
        muiSelectAllCheckboxProps={{
          sx: (theme) => ({
            lineHeight: "16px",
            fontWeight: "400",
            fontSize: "12px",
            color: "var(--prinary-color-800)",
            fontFamily: "Inter",
          }),
        }}
        muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
        muiPaginationProps={{
          rowsPerPageOptions: [50, 100, 300, 500, 1000, 2000, 5000, 10000],
        }}
        initialState={{
          density: "compact",
          expanded: true, //expand all groups by default
          grouping: columnGrouping, //an array of columns to group by by default (can be multiple)
          pagination: { pageIndex: 0, pageSize: 50 },
          showColumnFilters: true,
          columnVisibility: columnsVisibility,
          // sorting: { id: "Name", desc: false }, //sort by state by default
        }}
        // muiToolbarAlertBannerChipProps={{ color: "primary" }}

        // manualFiltering  // for termp comment filteron column
        // manualPagination
        // manualSorting
        // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
        // onGlobalFilterChange={setGlobalFilter}
        // onPaginationChange={setPagination}
        // onSortingChange={setSorting}
        // rowCount={rowCount}
        // enableColumnVirtualization={false}
        // rowVirtualizerOptions={{
        //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
        //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
        // }}
        // enableColumnVirtualization
        // state={{
        //   // columnFilters, // for termp comment filteron column
        //   // globalFilter,
        //   isLoading,
        //   // pagination,
        //   showAlertBanner: isError,
        //   showProgressBars: isRefetching,
        //   // sorting,
        // }}
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              p: "0.5rem",
              flexWrap: "wrap",
            }}
          >
            <Button
              // size="small"
              className="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => onBtExport([], "AllData")}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Export All In Excel
            </Button>
            <Button
              // size="small"
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() =>
                downloadPDF("", "alldata", table.getVisibleFlatColumns())
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              EXPORT ALL IN PDF
            </Button>
            <Button
              // size="small"
              className="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => onBtExport(table.getSelectedRowModel().rows, "")}
              startIcon={<FileDownloadIcon />}
              variant="contained"
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
            >
              EXPORT SELECTED ROWS IN EXCEL
            </Button>
            <Button
              // size="small"
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              //only export selected rows
              onClick={() =>
                downloadPDF(
                  table.getSelectedRowModel().rows,
                  "selectedrow",
                  table.getVisibleFlatColumns()
                )
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              EXPORT SELECTED ROWS IN PDF
            </Button>
            <Button
              // size="small"
              className="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => onBtExport(table.getRowModel().rows, "")}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Export Page Rows In Excel
            </Button>
            <Button
              disabled={table.getRowModel().rows.length === 0}
              //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
              onClick={() =>
                downloadPDF(
                  table.getRowModel().rows,
                  "selectedrow",
                  table.getVisibleFlatColumns()
                )
              }
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              variant="contained"
              startIcon={<FileDownloadIcon />}
            >
              Export Page Rows In Pdf
            </Button>
          </Box>
        )}
      /> */}
    </>
  );
}

export default CommonMatrialReactTableServerSideRender;
